import {Divider, Stack, Typography, useTheme} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import AlertErrorCodeBar from 'presentation/components/AlertErrorCodeBar';
import {translations} from 'presentation/translations-new';
import React, {Fragment} from 'react';
import {useBilletDetails} from '../../hooks/useBilletDetails';

const {alertWarning, interestAndFines, attention} =
	translations['pt-br'].privateFlow.myFinancial.billetDetails;

const ExpiredDataInfo = () => {
	const {colors} = useTheme();
	const {isExpired, showAlertErrorCodeBar} = useBilletDetails();

	if (!isExpired) {
		return null;
	}

	return (
		<Fragment>
			{showAlertErrorCodeBar ? <AlertErrorCodeBar isDetail /> : null}
			<Stack gap={'16px'}>
				<AlertInfo.Root severity="warning">
					<AlertInfo.Title title={attention} />
					<AlertInfo.Description>{alertWarning}</AlertInfo.Description>
				</AlertInfo.Root>
				<Divider />
				<Typography fontSize={'12px'} color={colors.light.text.secondary}>
					{interestAndFines}
				</Typography>
			</Stack>
		</Fragment>
	);
};

export {ExpiredDataInfo};
